import React, { useEffect, useState } from "react";
import ModalComponent from "../../../components/modals/ModalComponent";
import { RejectVerifyDoc } from "../../../api/request/dashboard/dashboard";
import toast from "react-hot-toast";
import { Form, Input } from "antd";
import LoadableButton from "../../../components/button/LoadableButton";

const VerifyReasonDocModal = ({
  isOpen,
  setIsOpen,
  verifyData,
  getDashboardDetails,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [verifyForm] = Form.useForm();

  const handleReject = async (value) => {
    setIsLoading(true);
    try {
      const params = {
        document_id: verifyData?.id,
        reason_of_review_doc: value?.reason,
      };
      const { data } = await RejectVerifyDoc(params);
      if (data?.status) {
        toast.success(data?.message);
        setIsOpen(false);
        getDashboardDetails();
      }
    } catch (error) {
      if (error?.response?.data?.message)
        toast.error(error?.response?.data?.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!isOpen) verifyForm?.resetFields();
  }, [isOpen]);

  return (
    <>
      <ModalComponent
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        title="Request Changes"
      >
        <Form
          autoComplete="off"
          layout="vertical"
          form={verifyForm}
          onFinish={handleReject}
        >
          <Form.Item
            name="reason"
            label="Request Changes"
            className="mb-0"
            rules={[{ required: true, message: "Please enter reason" }]}
          >
            <Input.TextArea rows={4} placeholder="Request Changes" />
          </Form.Item>

          <div className="text-center mt-5">
            <LoadableButton
              type="submit"
              lable="Submit"
              isLoading={isLoading}
              loadingLable="Submitting..."
            />
          </div>
        </Form>
      </ModalComponent>
    </>
  );
};

export default VerifyReasonDocModal;
